import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
    const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
    return {
        Authorization: `Bearer ${tokenData.accessToken}`,
        'Content-Type': 'application/json'
    };
};

export const getLoyaltyPoints = async (filter = {}) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/LoyaltyPoints/get`, filter, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching loyalty points:", error);
        throw error;
    }
};

export const saveLoyaltyPoints = async (loyaltyPointsData) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/LoyaltyPoints/save`, loyaltyPointsData, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error saving loyalty points:", error);
        throw error;
    }
};

export const checkLoyaltyPointsUsage = async (id) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/LoyaltyPoints/check-usage/${id}`, {}, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error checking loyalty points usage:", error);
        throw error;
    }
};
